/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Unit_ColInputs */

const vi_order_unit_col = /** @type {(inputs: Order_Unit_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn vị`)
};

/**

* @param {Order_Unit_ColInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_unit_col = /** @type {((inputs?: Order_Unit_ColInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Unit_ColInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_unit_col(inputs)
});